<script setup lang="ts">
import { ICON_PATHS, type IconName } from './icons'

defineProps<{ name: IconName }>()
</script>

<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" v-html="ICON_PATHS[name]" />
</template>
